"use strict";
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
// eslint gives error about missing key prop in tr, th, etc, but the key is part of the element's props */
/* eslint-disable react/jsx-key */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_table_1 = require("react-table");
const react_i18next_1 = require("react-i18next");
const pages_1 = require("chaire-lib-frontend/lib/components/pages");
const faSyncAlt_1 = require("@fortawesome/free-solid-svg-icons/faSyncAlt");
const faFolder_1 = require("@fortawesome/free-solid-svg-icons/faFolder");
const faSortAmountDown_1 = require("@fortawesome/free-solid-svg-icons/faSortAmountDown");
const faSortAmountDownAlt_1 = require("@fortawesome/free-solid-svg-icons/faSortAmountDownAlt");
const faBolt_1 = require("@fortawesome/free-solid-svg-icons/faBolt");
const faListCheck_1 = require("@fortawesome/free-solid-svg-icons/faListCheck");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const Status = __importStar(require("chaire-lib-common/lib/utils/Status"));
const reviewDecisionStatusHelper_1 = require("../../../services/admin/reviewDecisionStatusHelper");
// User react-table to handle a few table functionalities like paging and filtering
const InterviewList = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)('main');
    const { getTableProps, prepareRow, headerGroups, page, canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, 
    // Get the state from the instance
    state: { pageIndex, pageSize, filters, sortBy }, setSortBy } = (0, react_table_1.useTable)({
        columns: props.columns,
        data: props.data,
        initialState: { pageIndex: 0, pageSize: 100, sortBy: props.initialSortBy },
        // We are handling our own pagination by the server queries, we don't have all the data loaded at once
        manualPagination: true,
        // Filters are also handled manually by the query to the server
        manualFilters: true,
        // Sort handled by the query to the server
        manualSortBy: true,
        pageCount: props.pageCount
    }, react_table_1.useFilters, react_table_1.useSortBy, react_table_1.usePagination);
    // Listen for changes in pagination and filters and use the state to fetch our new data
    react_1.default.useEffect(() => {
        props.fetchData({ pageIndex, pageSize, filters, sortBy });
    }, [props.fetchData, pageIndex, pageSize, filters, sortBy]);
    const handleSortingChange = (columnId, sortOrder = 'asc') => {
        // TODO: handle multi-cooumns sorting
        const newSort = [{ id: columnId, desc: sortOrder === 'desc' }];
        setSortBy(newSort);
    };
    return props.loading ? (react_1.default.createElement("div", { className: "admin-widget-container" },
        react_1.default.createElement(pages_1.LoadingPage, null))) : (react_1.default.createElement("div", { style: {
            flexDirection: 'row',
            flex: '0 0 auto',
            display: props.showInterviewList || (0, LodashExtensions_1._isBlank)(props.validationInterview) ? 'block' : 'none'
        } },
        props.validationInterview !== null && (react_1.default.createElement("button", { title: t('admin:HideInterviewList'), onClick: () => props.interviewListChange(false) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faFolder_1.faFolder }))),
        react_1.default.createElement("div", { className: 'admin-widget-container _overflow-scroll' },
            react_1.default.createElement("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    props.fetchData({ pageIndex, pageSize, filters, sortBy });
                }, title: t('admin:refreshValidationList') },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faSyncAlt_1.faSyncAlt })),
            react_1.default.createElement("span", { className: "_pale" }, "\u00A0|\u00A0"),
            react_1.default.createElement("a", { href: "#", className: props.batchAuditLoading ? '_disabled' : '', onClick: (e) => {
                    e.preventDefault();
                    if (!props.batchAuditLoading) {
                        props.runBatchAudits(false, filters, pageIndex, pageSize, sortBy);
                    }
                }, title: t('admin:batchRunAudits') },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faListCheck_1.faListCheck })),
            react_1.default.createElement("span", { className: "_pale" }, "\u00A0|\u00A0"),
            react_1.default.createElement("a", { href: "#", className: `_together ${props.batchAuditLoading ? '_disabled' : ''}`, onClick: (e) => {
                    e.preventDefault();
                    if (!props.batchAuditLoading) {
                        props.runBatchAudits(true, filters, pageIndex, pageSize, sortBy);
                    }
                }, title: t('admin:batchRunAuditsWithExtended') },
                react_1.default.createElement("span", { className: "_small" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBolt_1.faBolt })),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faListCheck_1.faListCheck })),
            props.batchAuditLoading && (react_1.default.createElement("span", { className: "_small", style: { marginLeft: '10px' } }, t('admin:runningBatchAudits'))),
            props.batchAuditResult && (react_1.default.createElement("span", { className: "_small", style: { marginLeft: '10px' } }, Status.isStatusError(props.batchAuditResult) ? (react_1.default.createElement("span", { className: "_error _red" }, t('admin:batchAuditError', {
                error: typeof props.batchAuditResult.error === 'string'
                    ? props.batchAuditResult.error
                    : props.batchAuditResult.error instanceof Error
                        ? props.batchAuditResult.error.message
                        : String(props.batchAuditResult.error)
            }))) : (t('admin:batchAuditResult', {
                total: props.batchAuditResult.result.totalCount,
                processed: props.batchAuditResult.result.processed,
                succeeded: props.batchAuditResult.result.succeeded,
                failed: props.batchAuditResult.result.failed
            })))),
            headerGroups.map((headerGroup, i) => (react_1.default.createElement("div", Object.assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column, j) => column.Filter ? react_1.default.createElement("div", { key: `columnHeader_${i}${j}` }, column.render('Filter')) : null)))),
            react_1.default.createElement("ul", Object.assign({ className: "_small" }, getTableProps()), props.columns.map((column, j) => column.enableSortBy === true ? (react_1.default.createElement("li", { key: `columnHeaderSort_${j}` },
                react_1.default.createElement("span", { className: "", key: "sortColumnLabel" }, column.label),
                react_1.default.createElement("a", { className: `faIconRight${sortBy.length === 1 &&
                        sortBy[0].id === column.accessor.toString() &&
                        sortBy[0].desc !== true
                        ? ' _active-background _blue'
                        : ''}`, onClick: (e) => {
                        e.preventDefault();
                        if (column.accessor.toString() !== sortBy[0].id || sortBy[0].desc === true) {
                            handleSortingChange(column.accessor.toString(), 'asc');
                        }
                    }, key: "sortAsc" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faSortAmountDownAlt_1.faSortAmountDownAlt })),
                react_1.default.createElement("a", { className: `faIconRight${sortBy.length === 1 &&
                        sortBy[0].id === column.accessor.toString() &&
                        sortBy[0].desc === true
                        ? ' _active-background _blue'
                        : ''}`, onClick: (e) => {
                        e.preventDefault();
                        if (column.accessor.toString() !== sortBy[0].id || sortBy[0].desc !== true) {
                            handleSortingChange(column.accessor.toString(), 'desc');
                        }
                    }, key: "sortDesc" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faSortAmountDown_1.faSortAmountDown })))) : null)),
            react_1.default.createElement("ul", Object.assign({ className: "_small" }, getTableProps()), page.map((row) => {
                var _a;
                prepareRow(row);
                return (react_1.default.createElement("li", Object.assign({ title: row.original.uuid, className: ((_a = props.validationInterview) === null || _a === void 0 ? void 0 : _a.uuid) === row.original.uuid
                        ? '_active-background _blue'
                        : (0, reviewDecisionStatusHelper_1.getInterviewListRowClassName)({
                            reviewStatus: row.original.review_status,
                            isCompleted: row.original.is_completed
                        }) }, row.getRowProps()), row.cells.map((cell, index) => {
                    return (react_1.default.createElement("span", Object.assign({}, cell.getCellProps()),
                        index > 0 ? ' • ' : '',
                        cell.render('Cell')));
                })));
            }))),
        react_1.default.createElement("div", { className: "admin-widget-container pagination" },
            react_1.default.createElement("span", null, t('main:ShowingNofX', { n: page.length, x: props.itemCount })),
            react_1.default.createElement("br", null),
            react_1.default.createElement("button", { onClick: () => gotoPage(0), disabled: !canPreviousPage }, '<<'),
            ' ',
            react_1.default.createElement("button", { onClick: () => previousPage(), disabled: !canPreviousPage }, '<'),
            ' ',
            react_1.default.createElement("button", { onClick: () => nextPage(), disabled: !canNextPage }, '>'),
            ' ',
            react_1.default.createElement("button", { onClick: () => gotoPage(pageCount - 1), disabled: !canNextPage }, '>>'),
            ' ',
            react_1.default.createElement("span", null, t('main:PageNofX', { n: pageIndex + 1, x: pageOptions.length })),
            react_1.default.createElement("span", null,
                "| ",
                t('main:GoToPage'),
                ":",
                ' ',
                react_1.default.createElement("input", { type: "number", defaultValue: pageIndex + 1, onBlur: (e) => {
                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                        gotoPage(page);
                    }, style: { width: '100px' } })),
            ' ',
            react_1.default.createElement("select", { value: pageSize, onChange: (e) => {
                    setPageSize(Number(e.target.value));
                } }, [100, 200, 300, 400, 500].map((pageSize) => (react_1.default.createElement("option", { key: pageSize, value: pageSize }, t('main:ShowN', { n: pageSize }))))))));
};
exports.default = InterviewList;
//# sourceMappingURL=InterviewList.js.map